export const forPhoneOnly = "(max-width: 599px)";
